import { createRequest } from '../helpers/api_utils';
import {
  fetchJSON,
  fetchWithUnauthorized,
} from '../helpers/fetchWithUnauthorized';
import { apiUrl } from './api_url';

export interface IAccessControl {
  resourceId: string;
  resourceType: string;
  entries: {
    orgUserId: string;
    permissions: string[];
  }[];
}

export interface IAccessControlList {
  resourceId: string;
  resoruceType: string;
}

export interface IDeleteAccessControl {
  orgUserId: string;
  resourceId: string;
  resourceType: string;
}

export interface IUser {
  firstName: string;
  lastName: string;
  email: string;
  timeZone?: string | null;
  id: string;
}

export interface IOrgUser {
  user: IUser;
  organizationId: string;
  roles: string[];
  groups: string[];
  isCandidate: boolean;
  lastActive: number;
  deletedAt: string | null;
  _cls: string;
  id: string; // orgUserId
  reportingManager: string;
  organizationUnitId: string;
  jobTitle: string;
}

export interface IAccessControlEntry {
  orgUser: IOrgUser;
  resourceId: string;
  resourceType: string;
  permissions: string[];
  id: string;
}

export interface IAccessControlListRequest {
  resourceId: string;
  resourceType: string;
}

export type PermissionType = 'read' | 'write' | 'delete';

export interface IUserDisplay {
  firstName: string;
  lastName: string;
  email: string;
  id: string;
  orgUserId?: string;
  permissions: PermissionType[];
}

const apiEndpoint = `${apiUrl}/access-control`;

export async function createAccessControl(accessControl: IAccessControl) {
  const request = createRequest(
    apiEndpoint,
    'POST',
    'application/json',
    true,
    accessControl,
  );
  return fetchWithUnauthorized(request);
}

export async function fetchAccessControlList(
  resourceId: string,
  resourceType: string,
): Promise<IAccessControlEntry[]> {
  const request = createRequest(
    `${apiEndpoint}/list`,
    'POST',
    'application/json',
    true,
    {
      resourceId,
      resourceType,
    },
  );
  return fetchJSON<IAccessControlEntry[]>(request);
}

export async function checkAccessControlList(
  accessControlList: IAccessControlList,
) {
  const body = {
    accessControlListCheckElement: accessControlList,
  };
  const request = createRequest(
    `${apiEndpoint}/list`,
    'POST',
    'application/json',
    true,
    body,
  );
  return fetchWithUnauthorized(request);
}

export function deleteAccessControl(deleteAccessControl: IDeleteAccessControl) {
  const request = createRequest(
    apiEndpoint,
    'DELETE',
    'application/json',
    true,
    deleteAccessControl,
  );
  return fetchWithUnauthorized(request);
}
